/* eslint-disable import/default */
import 'materialize-css/dist/css/materialize.min.css';
import "babel-polyfill";
import './styles/styles.scss';
import 'react-redux-toastr/src/styles/index.scss';
import 'font-awesome/css/font-awesome.min.css';
import 'animate.css/animate.min.css';
require('./favicon.ico');

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import routes from './routes';
import configureStore from './store/configureStore';
import { IntlProvider } from 'react-intl';
import { Log } from 'oidc-client';
import injectTapEventPlugin from 'react-tap-event-plugin';
import userManager from './utils/userManager';
import { OidcProvider } from 'redux-oidc';
import RouteWithSubRoutes from './RouteWithSubRoutes';
import { BrowserRouter } from 'react-router-dom';
import Perf from 'react-addons-perf';
import * as userActions from './actions/userActions';
import ReduxToastr from 'react-redux-toastr';
import ReactUpdates from "react-dom/lib/ReactUpdates";
import ReactDefaultBatchingStrategy from "react-dom/lib/ReactDefaultBatchingStrategy";
import log, { setStore } from 'utils/logger';
import { publicPath } from '../tools/publicPath';





injectTapEventPlugin();



//Require https exempting localhost for development
if (location.hostname !== 'localhost' && location.protocol !== 'https:') {
    location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
}

const store = configureStore();
setStore(store);

if (process.env.NODE_ENV !== 'production') {
    window.Perf = Perf;
}

const oidclogger = {
    error: (error) => {
        store.dispatch(userActions.userLoginFailed(`Login failed (${error}). Please try again. If you are still unable to login please create a ticket.`));
    },
    info: () => { },
    warn: () => { }
};

Log.logger = oidclogger;
Log.level = Log.ERROR;

const baseName = publicPath(process.env.WOW_API_ENV);

render(
    <IntlProvider locale="en">
        <Provider store={store}>
            <OidcProvider store={store} userManager={userManager}>

                <BrowserRouter basename={baseName}>
                    <div>
                        {routes.map((route, i) => (<RouteWithSubRoutes key={i} {...route} />))}

                        <ReduxToastr
                            timeOut={4000}
                            newestOnTop={false}
                            preventDuplicates
                            position="top-right"
                            transitionIn="fadeIn"
                            transitionOut="fadeOut"
                            progressBar />

                    </div>
                </BrowserRouter>

            </OidcProvider>

        </Provider>
    </IntlProvider>, document.getElementById('app'));


// WEBPACK FOOTER //
// ./src/index.js